// extracted by mini-css-extract-plugin
export default {"wigwag-label":"_3MmpBeXu_BJdJvVc_vC","icons":"xYQBdkn3q_j2fMlDkn3W"};